import { createFileRoute, redirect } from "@tanstack/react-router";
import { allLegalDocuments } from "content-collections";
import { LegalDocumentPage } from "@/components/misc/legal-document-page";
import {
	getCurrentLegalVersion,
	listVersionsForDocument,
} from "@/lib/legal-versions";
import { isLegalDocumentModuleEnabled } from "@/lib/modules";
import { seo } from "@/utils/seo";

export const Route = createFileRoute("/_marketing/legal/$slug/")({
	component: RouteComponent,
	beforeLoad: ({ params }) => {
		const { slug } = params;
		const document = getCurrentLegalVersion(slug, allLegalDocuments);
		if (!document || !isLegalDocumentModuleEnabled(document.module)) {
			throw redirect({ to: "/legal" });
		}
		const versions = listVersionsForDocument(slug, allLegalDocuments);
		if (versions.length > 1 && versions.every((v) => !v.isCurrent)) {
			throw redirect({
				to: "/legal/$slug/$versionId",
				params: { slug, versionId: versions[0].versionId },
			});
		}
		return { document };
	},
	head: ({ params: { slug } }) => {
		const document = getCurrentLegalVersion(slug, allLegalDocuments);
		const lastUpdatedIso = document?.lastUpdated
			? new Date(document.lastUpdated as string | Date).toISOString()
			: undefined;
		return {
			...seo({
				title: document?.title
					? `${document.title} - Legal and Security`
					: "Legal and Security",
				description: document?.summary,
				keywords: "legal, privacy, security, terms, subprocessors",
				type: "Article",
				datePublished: lastUpdatedIso,
				dateModified: lastUpdatedIso,
			}),
		};
	},
});

export function RouteComponent() {
	const { document } = Route.useRouteContext();

	return (
		<LegalDocumentPage
			key={`${document.documentId}-${document.versionId}`}
			document={document}
			allDocuments={allLegalDocuments}
		/>
	);
}
